// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, roles = [] }) {
  const { user } = useContext(AuthContext);

  // 1) If no user, send to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  // 2) If user exists but role not allowed, you could send to "/" or show a 403 page
  if (roles.length && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  // 3) Otherwise, render the protected children
  return children;
}
